import { Link } from "react-router-dom";
import Loader from "../../components/Shared/Loader";
import { useState, useEffect } from "react";
import { useCompany } from "../../hooks/useCompany";
import { Table, Input, Space, Button } from "antd";
import { SearchOutlined, ArrowRightOutlined } from '@ant-design/icons';
import CardHeader from "../../components/Shared/CardHeader";
import { api } from '../../services/axios';
import { toast } from "react-toastify";

interface ProjectType {
    projectId?: string;
    key: string;
    projectName: string;
    investment: string;
}

export default function SummaryOfValues() {
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const { company } = useCompany()
    const [projects, setProjects] = useState<ProjectType[]>([]);
    const [totalProjects, setTotalProjects] = useState(0);

    async function fetchProjects() {
        try {
            setLoading(true);
            const response = await api.get(`Expenditure/GetProjectsTotalsByService/${company.serviceId}`);

            if (response.data.statusCode === 200) {
                const projectData = response.data.data.map((project: any, index: number) => ({
                    key: project.projectId ? String(project.projectId) : `${index}-${project.projectName}`,
                    projectId: project.projectId,
                    projectName: project.projectName,
                    investment: project.formattedValue
                }));

                setProjects(projectData);
                setTotalProjects(projectData.length);
            } else {
                toast.error(response.data.errors?.[0] || 'Erro ao carregar projetos');
            }
        } catch (error) {
            toast.error('Erro ao carregar projetos');
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchProjects();
    }, [company.serviceId]);

    const columns = [
        {
            title: 'Projetos',
            dataIndex: 'projectName',
            key: 'projectName',
            width: '65%',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: {
                setSelectedKeys: (keys: React.Key[]) => void;
                selectedKeys: React.Key[];
                confirm: () => void;
            }) => (
                <div style={{ padding: 8, width: '100%' }}>
                    <Input
                        placeholder="Buscar Projetos..."
                        value={selectedKeys[0] as string}
                        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={confirm}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={confirm}
                        size="small"
                        style={{ width: '100%', backgroundColor: '#0000A4', color: 'white', border: 'none' }}
                    >
                        <span style={{ color: 'white' }}>Buscar</span>
                    </Button>
                </div>
            ),
            filterIcon: (filtered: boolean) => (
                <SearchOutlined style={{ color: filtered ? '#0000A4' : undefined }} />
            ),
            onFilter: (value: string | number | boolean, record: ProjectType) =>
                record.projectName.toLowerCase().includes(value.toString().toLowerCase()),
        },
        {
            title: 'Investimentos',
            dataIndex: 'investment',
            key: 'investment',
            width: '25%',
            sorter: (a: ProjectType, b: ProjectType) => {
                const numA = parseFloat(a.investment.replace(/[^\d,]/g, '').replace(',', ''));
                const numB = parseFloat(b.investment.replace(/[^\d,]/g, '').replace(',', ''));
                return numA - numB;
            },
        },
        {
            title: 'Ações',
            key: 'actions',
            width: '10%',
            render: (_: any, record: ProjectType) => (
                <Space size="middle">
                    {record.projectId ? (
                        <Link
                            to={`/${company.serviceId}/summaryOfValues/projects/${record.projectId}`}
                            style={{ color: '#0000A4' }}
                        >
                            <ArrowRightOutlined style={{ color: '#0000A4', fontSize: '16px' }} />
                        </Link>
                    ) : null}
                </Space>
            ),
        },
    ];

    return (
        <>
            {loading && <Loader />}
            <div className="card">
                <CardHeader
                    pageName={"Identificação Técnica"}
                    hasPageBefore={false}
                />
                <div style={{ margin: '16px' }}>
                    <Table
                        columns={columns}
                        dataSource={projects}
                        bordered
                        pagination={{
                            current: currentPage,
                            onChange: (page) => setCurrentPage(page),
                            pageSize: 10,
                        }}
                    />
                </div>
            </div>
        </>
    );
}